// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608071940/js/" + chunkId + "." + {"44":"b4a9b967","225":"eb94d8c9","481":"0223c0ce","486":"b46b2db0","770":"75c9b10e"}[chunkId] + ".0.3989633267538335.chunk.js";
};